export const impactData = {
  badge: "OUR IMPACT",
  headline: "Our Impact in Numbers",
  description:
    "We've helped aesthetic clinics across UK/Ireland generate hundreds of booked appointments, streamline their operations, and grow consistently year after year. Every result is backed by proven strategies, data-driven decisions, and a system that scales with you.",
  achievements: [
    {
      text: "£250K/Year in Patient Revenue Generated",
    },
    {
      text: "Average +200% Increase in Booking Rates Compared to Regular Agencies",
    },
    {
      text: "90% Client Retention Rate — Clinics Stay Because It Works",
    },
  ],
  image:
    "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&q=80",
};
